module.exports = __webpack_public_path__ + "static/media/22_B.d82573fe.png";